import { Component, OnInit, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
  selector: 'mobile-row-container',
  templateUrl: './mobile-row-container.template.html',
  styleUrls: ['./mobile-row-container.styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileRowContainer {
  @Input() row$: any;
  @Input() content$: any;
  private eventHook: Subscription;
  private dataService: BehaviorSubject<Object>;

  constructor(
    private coreEffects: CoreEffects,
    private eventInteraction: EventInteraction,
    private route: ActivatedRoute,
    public elementReference: ElementRef
  ) {
    this.dataService = new BehaviorSubject({});
   }


  ngOnInit() {
    this.content$ = this.dataService.asObservable();
    this.coreEffects.getAsyncChildDataAsObservable(this.dataService, this.row$, this.route.snapshot.params, true);
  }

  ngOnDestroy(): void {
    if (this.dataService){
      this.dataService.complete();
      //this.dataService.unsubscribe();
      this.dataService = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/row-container/mobile/mobile-row-container.component.ts